import Vue from "vue";

export async function index(params = {}) {
  const response = await Vue.prototype.$http.get("/brands", {
    params
  });

  return response.data;
}

export async function show(id, params = {}) {
  const response = await Vue.prototype.$http.get("/brands/" + id, {
    params
  });

  return response.data;
}

export async function store(payload) {
  const response = await Vue.prototype.$http.post("/brands", payload);
  
  return response.data;
}

export async function update(payload, id) {
  const response = await Vue.prototype.$http.put("/brands/" + id, payload);

  return response.data;
}

export async function destroy(id) {
  await Vue.prototype.$http.delete("/brands/" + id);

  return true;
}